'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Spinner.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Use the spinner as an indicator when something is loading.
 */
var Spinner = function Spinner(_ref) {
  var size = _ref.size;
  var spinnerClass = (0, _classnames2.default)('c-spinner', {
    'c-spinner--large': size === 'large'
  });
  return _react2.default.createElement('div', {
    className: spinnerClass
  }, _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }), _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }), _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }), _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }), _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }), _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }), _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }), _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }), _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }), _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }), _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }), _react2.default.createElement('div', {
    className: 'c-spinner__bar'
  }));
};
Spinner.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The size of the spinner */
  size: _propTypes2.default.oneOf(['normal', 'large'])
} : {};
Spinner.defaultProps = {
  size: 'normal'
};
exports.default = Spinner;